package com.appcreator.compose.actions.permission

import androidx.compose.runtime.Composable
import com.appcreator.blueprint.actions.permission.PermissionRequestAction
import com.appcreator.compose.actions.Performer

class PermissionRequestPerformer(private val action: PermissionRequestAction): Performer {
    @Composable
    override fun deferred(): Performer.Deferred {
        return PermissionRequestPerformerDeferred(action)
    }
}

@Composable
expect fun PermissionRequestPerformerDeferred(action: PermissionRequestAction): Performer.Deferred